// frontend/src/components/portfolio/PreviewModal.tsx
import React from 'react';
import { Dialog, IconButton, Box } from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';
import BlockRenderer from '../public/BlockRenderer';
import PortfolioHeader from '../public/PortfolioHeader';
import PortfolioFooter from '../public/PortfolioFooter';
import { Portfolio } from '../../types/Portfolio';

interface PreviewModalProps {
  open: boolean;
  onClose: () => void;
  portfolio: Portfolio;
}

const PreviewModal: React.FC<PreviewModalProps> = ({ open, onClose, portfolio }) => {
  const theme = {
    primaryColor: portfolio.theme?.primaryColor || '#000000',
    accentColor: portfolio.theme?.accentColor || '#FF0000',
    fontFamily: portfolio.theme?.fontFamily,
    logo: portfolio.theme?.logo,
    watermark: portfolio.theme?.watermark
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullScreen
      PaperProps={{
        sx: {
          bgcolor: '#ffffff',
          margin: 0,
          maxHeight: '100vh'
        }
      }}
    >
      {/* Close Button */}
      <Box
        sx={{
          position: 'fixed',
          top: 16,
          right: 16,
          zIndex: 9999,
          bgcolor: 'rgba(0, 0, 0, 0.7)',
          borderRadius: '50%',
          '&:hover': {
            bgcolor: 'rgba(0, 0, 0, 0.9)'
          }
        }}
      >
        <IconButton
          onClick={onClose}
          sx={{
            color: 'white',
            '&:hover': {
              bgcolor: 'transparent'
            }
          }}
        >
          <CloseIcon />
        </IconButton>
      </Box>

      {/* Portfolio Content */}
      <Box
        sx={{
          width: '100%',
          height: '100vh',
          overflow: 'auto',
          fontFamily: theme.fontFamily || 'inherit'
        }}
      >
        {/* Header with Logo */}
       <PortfolioHeader
  logo={theme.logo}
  portfolioTitle={portfolio.title}
  contactName={portfolio.investorContext?.contactName}
  theme={theme}
/>

        {/* Portfolio Blocks */}
        <BlockRenderer
          sections={portfolio.sections}
          portfolioTitle={portfolio.title}
          theme={theme}
        />

        {/* Footer with Logo */}
        <PortfolioFooter 
          logo={theme.logo}
          portfolioTitle={portfolio.title}
          contactName={portfolio.investorContext?.contactName}
          theme={theme}
        />
      </Box>
    </Dialog>
  );
};

export default PreviewModal;